module.exports = __webpack_public_path__ + "static/media/bear.efe42190.png";